module.exports = __webpack_public_path__ + "media/images/country_flags/dz-f3f8107061b0fda0a08a4d65325b6ba7.png";